/* Under the ticket CTA in the detail panel. */
.eventBlock {
  align-self: stretch;
  margin-top: 14px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
}

.eventHeading {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.eventBlock .hint {
  margin: 0 0 14px;
}

.hint {
  margin: -6px 0 14px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.text {
  margin: -4px 0 16px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-body);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
}

/* Outlined, beside the filled ticket / booking CTA it supports. */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 48px;
  padding: 0 28px;
  border: 1px solid var(--primary);
  border-radius: var(--radius-pill);
  background: var(--card);
  color: var(--primary);
  font: 500 15px var(--font-body);
  cursor: pointer;
}

.button:hover {
  background: var(--band);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text);
  font: 500 14px var(--font-body);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 4px;
  cursor: pointer;
}

.map {
  display: block;
  width: 100%;
  height: 420px;
  margin-top: 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  box-sizing: border-box;
  scroll-margin: 16px;
}

/* In the page's main column, above the description. */
.wideMap {
  height: 480px;
  margin: 0 0 32px;
}

.areasLink {
  margin: 8px 0 0;
  font-size: 14px;
}

.areasLink a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 4px;
}

/* The city block on a guide: a card set off from the article body. */
.card {
  margin-top: 40px;
  padding: 28px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--card);
}

@media (max-width: 767px) {
  .card {
    padding: 20px;
  }
}
